import { ActionContext } from 'vuex'
import util from '@/utils/classToObject'
import actionsTypes from '@/store/all-action-types'
import types from './all-mutation-types'
import { IRootState, emptyAction, actionEnsure } from '@/store'
import { IUiState } from './state'

export class UiAction {       
    public [types.UI_CLOSE_SNACKBAR](context: ActionContext<IUiState, IRootState>) {
        return new Promise((resolve) => {
            context.commit(types.UI_CLOSE_SNACKBAR)
            resolve()
        })
    }
    public [types.UI_ADD_SNACK_MESSAGE](context: ActionContext<IUiState, IRootState>,message:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_ADD_SNACK_MESSAGE  ,message)
            resolve()
        })
    }

    public [types.UI_SET_CONTENT_HEIGHT](context: ActionContext<IUiState, IRootState>,height:number) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_CONTENT_HEIGHT,height)
            resolve()
        })
    }    

    public [types.UI_SET_RIGHT_DRAWER_OPEN](context: ActionContext<IUiState, IRootState>,open:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_RIGHT_DRAWER_OPEN,open)
            resolve()
        })
    }      

    public [types.UI_SET_RIGHT_DRAWER_ENABLE](context: ActionContext<IUiState, IRootState>,enable:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_RIGHT_DRAWER_ENABLE,enable)
            resolve()
        })
    }    

    public [types.UI_SET_DRAWER_OPEN](context: ActionContext<IUiState, IRootState>,open:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_DRAWER_OPEN,open)
            resolve()
        })
    }  

    public [types.UI_SET_DRAWER_ENABLE](context: ActionContext<IUiState, IRootState>,enable:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_DRAWER_ENABLE,enable)
            resolve()
        })
    }  
    
    public [types.UI_SET_CART_VISIBLITY](context: ActionContext<IUiState, IRootState>,visibility:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_CART_VISIBLITY,visibility)
            resolve()
        })
    }  

    //////////////////////////////////////////////////////////////////
    // USER 
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_USER](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_USER  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_USER_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_USER_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_USER_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_USER_BY  ,sort)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // MAIL_TEMPLATE
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_MAIL_TEMPLATE](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_MAIL_TEMPLATE  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_MAIL_TEMPLATE_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_MAIL_TEMPLATE_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_MAIL_TEMPLATE_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_MAIL_TEMPLATE_BY  ,sort)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // MAIL_SKIN
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_MAIL_SKIN](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_MAIL_SKIN  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_MAIL_SKIN_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_MAIL_SKIN_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_MAIL_SKIN_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_MAIL_SKIN_BY  ,sort)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // PISCINE
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_PISCINE](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_PISCINE  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_PISCINE_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_PISCINE_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_PISCINE_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_PISCINE_BY  ,sort)
            resolve()
        })
    }
    public [types.UI_SET_MONTH_PISCINE](context: ActionContext<IUiState, IRootState>,month:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_MONTH_PISCINE  , month)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // ACTIVITY
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_ACTIVITY](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_ACTIVITY  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_ACTIVITY_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_ACTIVITY_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_ACTIVITY_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_ACTIVITY_BY  ,sort)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // FORFAIT
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_FORFAIT](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_FORFAIT  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_FORFAIT_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_FORFAIT_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_FORFAIT_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_FORFAIT_BY  ,sort)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // MNS
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_MNS](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_MNS  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_MNS_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_MNS_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_MNS_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_MNS_BY  ,sort)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // CONTACT
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_CONTACT](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_CONTACT  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_CONTACT_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_CONTACT_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_CONTACT_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_CONTACT_BY  ,sort)
            resolve()
        })
    }
    public [types.UI_SET_MONTH_CONTACT](context: ActionContext<IUiState, IRootState>,month:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_MONTH_CONTACT  , month)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // NEWSLETTER
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_NEWSLETTER](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_NEWSLETTER  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_NEWSLETTER_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_NEWSLETTER_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_NEWSLETTER_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_NEWSLETTER_BY  ,sort)
            resolve()
        })
    }
    
    //////////////////////////////////////////////////////////////////
    // COURS
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_COURS](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_COURS  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_COURS_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_COURS_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_COURS_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_COURS_BY  ,sort)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // COMMANDE
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_COMMANDE](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_COMMANDE  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_COMMANDE_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_COMMANDE_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_COMMANDE_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_COMMANDE_BY  ,sort)
            resolve()
        })
    }
    public [types.UI_SET_MONTH_COMMANDE](context: ActionContext<IUiState, IRootState>,month:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_MONTH_COMMANDE  , month)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // FAMILY
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_FAMILY](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_FAMILY  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_FAMILY_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_FAMILY_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_FAMILY_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_FAMILY_BY  ,sort)
            resolve()
        })
    }
    
}

export default util.classToObject(UiAction)
